import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { GeneralAgentInput } from '@/lib/api/domains/general-agents';
import { keys } from '@/lib/query-keys';

export function useCreateGeneralAgent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: GeneralAgentInput) => api.generalAgents.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: keys.generalAgents.lists(),
      });
    },
  });
}
